import router from '@/router/index'
import UAParser from 'ua-parser-js'
import VueCookie from 'vue-cookie'
import routers from '@/router/systemRouters.js'
import { Base64 } from 'js-base64'
import { z } from 'zod'
import { redirectToChannelH5Return } from '@/config/channel-h5-return'
import { getFullPathname, getBaseStartPathname, getVueRoutePathnameFromUrl } from '@/config/app-base-path'
const CryptoJS = require('crypto-js')

// 手机号校验
export const mobileReg = (num) => {
  const reg = /^1(([3][0-9])|([4][0|1|4|6|7|8|9])|([5][0|1|2|3|5|6|7|8|9])|([6][2|3|5|6|7|8|9])|([7][0-9])|([8][0-9])|([9][0-9]))[0-9]{8}$/
  if (reg.test(num)) return true
}

// 获取用户手机号
export const getMobile = (userName) => {
  const key = 'ad98a1090ae0e851' // 十六位十六进制数作为密钥
  if (userName) {
    let result = decodeURIComponent(userName)
    if (result && result.length > 11) {
      if (/[a-zA-Z]/.test(result)) {
        result = Decrypt({
          key: key,
          word: result
        })
      }
      result = result.substring(0, 11)
    }
    return result
  } else {
    return userName
  }
}

// 缓存数据（存本地和cookie）
export const setLocalData = (key, value) => {
  const v = typeof value === 'object' ? JSON.stringify(value) : value
  localStorage.setItem(key, v)
  VueCookie.set(key, v)
}

// 获取缓存数据（本地或cookie）
export const getLocalData = (key) => {
  const v = localStorage.getItem(key) || VueCookie.get(key)
  try {
    const data = JSON.parse(v)
    return data
  } catch (error) {
    return v
  }
}

// 邮箱校验
export const emailReg = (email) => {
  const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
  if (reg.test(email)) return true
}

// 当前浏览器是否为微信浏览器
export const getBrowser = (para, callback) => {
  const isWX = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
  if (isWX) { // 微信浏览器
    return true
  } else { // 其他浏览器
    return false
  }
}

// 获取当前页面的URL 对其带的参数进行处理
export const getUrlPara = (para, callback) => {
  const paraArr = location.search.substring(1).split('&')
  for (let i = 0; i < paraArr.length; i++) {
    if (para === paraArr[i].split('=')[0]) {
      return window.decodeURIComponent(paraArr[i].split('=')[1])
    }
  }
  return ''
}

// 获取url链接的参数
export const getUrlPara2 = (url) => {
  const search = url.includes('?') ? url.split('?')[1] : (url.includes('=') ? url : '')
  const params = {}
  if (!search) return params
  const paraArr = search.split('&')
  for (let i = 0; i < paraArr.length; i++) {
    const temp = paraArr[i].split('=')
    params[temp[0]] = window.decodeURIComponent(temp[1])
  }
  return params
}

// 判断手机系统，1为android，2为ios
export const getOsFrom = (callback) => {
  try {
    const u = window.navigator.userAgent || 'Android'
    const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    if (isAndroid) { // 返回1是android
      return 'and'
    }
    if (isiOS) { // 返回2是ios
      return 'ios'
    }
    return 'and'
  } catch (e) {
    return 'and'
  }
}

// 判断手机机型类型（包含鸿蒙）
export const getOsType = () => {
  try {
    const ua = navigator.userAgent.toLowerCase()
    // 鸿蒙（必须先判断，避免被识别成 Android）
    if (ua.includes('harmony') || ua.includes('ohos')) {
      return 'harmony'
    } else if (ua.includes('iphone') || ua.includes('ipad') || ua.includes('ipod')) {
      // iOS
      return 'ios'
    } else if (ua.includes('android')) {
      // Android
      return 'and'
    }
    return 'and'
  } catch (e) {
    return 'and'
  }
}

// 转换时间戳
export const format = (now, fmt = 'yyyy-MM-dd') => {
  if (typeof now === 'string') {
    now = now.replace(/-/g, '/')
  }
  now = new Date(now)
  const o = {
    'M+': now.getMonth() + 1, // 月份
    'd+': now.getDate(), // 日
    'h+': now.getHours(), // 小时
    'm+': now.getMinutes(), // 分
    's+': now.getSeconds(), // 秒
    'q+': Math.floor((now.getMonth() + 3) / 3), // 季度
    S: now.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (now.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, String(o[k]).padStart(RegExp.$1.length, 0))
    }
  }
  return fmt
}

// 获取手机具体型号
export const getPhoneType = () => {
  try {
    var parser = new UAParser(navigator.userAgent)
    var os = parser.getOS()
    var device = parser.getDevice()
    var osStr = (os.name || '未知系统') + (os.version ? ' ' + os.version : '')
    var modelStr = device.model || ''
    return (osStr + ' ' + modelStr).trim()
  } catch (e) {
    return '未知型号'
  }
}

// ase解密
export const Decrypt = (parmse) => {
  let {
    key,
    word
  } = parmse
  key = CryptoJS.enc.Utf8.parse(key)
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}
// ase加密
export const Encrypt = (parmse) => {
  let {
    key,
    word
  } = parmse
  key = CryptoJS.enc.Utf8.parse(key)
  const encrypted = CryptoJS.AES.encrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.toString()
}

// 各平台各类型不同处理情况
export const handleByPlotform = (() => {
  const strategy = {
    service: plotform => {
      if (plotform && plotform.toLowerCase().includes('zfb')) return false
      return true
    }
  }
  return (type) => {
    return strategy[type](localStorage.getItem('lzCode'))
  }
})()

// 判断是线上还是开发环境打印日志
export const log = (...arg) => {
  const config = allHostList()
  try {
    if (config.originList.includes(location.origin)) { // 线上环境
      window.captureLog(...arg)
    } else {
      console.log(...arg)
    }
  } catch (e) {
    console.log(...arg)
  }
}

export const Debounce = (fn, t) => {
  const delay = t || 1500
  let timer
  return function () {
    const args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      clearTimeout(timer)
      timer = null
      return fn.apply(this, args)
    }, delay)
  }
}

// 节流，连续点击按钮控制（1500ms）
export const Throttle = (fn, t) => {
  const delay = t || 1500
  let before = new Date().getTime()
  let now = ''
  return function () {
    const args = [...arguments]
    if (!now) {
      fn.apply(this, args)
      before = now = new Date().getTime()
      return
    }
    now = new Date().getTime()
    if (now - before > delay) {
      fn.apply(this, args)
      before = now
    }
  }
}

// 风控 额度需要参数

export const RiskParmse = () => {
  var parser = new UAParser(navigator.userAgent)
  var os = parser.getOS()
  var osName = os.name || ''
  var isIOS = osName === 'iOS'
  var devOS = isIOS ? 'iOS' : osName === 'HarmonyOS' ? 'HarmonyOS' : 'Android'
  var model = {}
  Object.assign(model, {
    blackBox: localStorage.getItem('blackBox'),
    devOS: devOS,
    devType: isIOS ? 0 : 1,
    devOSVersion: String(os.version || ''),
    linktoken: localStorage.getItem('h5_repay') ? 'h5_repay' : getLocalData('appInfo') ? 'app' : 'h5'
  })
  return Base64.encode(JSON.stringify(model))
}

export const setInterceptBack = (function () {
  const interceptBacks = ['auth_video', 'auth_credit', 'auth_persioninfo', 'auth_result']
  const interceptRouters = routers.filter(item => interceptBacks.includes(item.name))
  return function (authed, open = true) {
    interceptRouters.forEach(item => {
      if (!authed) {
        item.meta.interceptLock = open
        return true
      }
      item.meta.interceptLock = open
      const tmp = authed.find(auth => auth.url === item.name)
      if (!tmp && item.name === 'auth_result') {
        item.meta.interceptBack = true
        item.meta.code = 'auth_result'
        return false
      }
      if (!tmp) {
        return true
      }
      if (tmp.status === 1) {
        item.meta.interceptBack = false
      } else {
        item.meta.interceptBack = true
        item.meta.code = tmp.code
      }
    })
  }
})()

// 去ocr
export const goOcrPage = function (url) {
  if (url) {
    url = `${url}?crtId=9&callback=${window.location.origin}${getFullPathname('/auth/loading')}`
    window.location.href = url
    return true
  }
  this.$router.push({ name: 'auth_identitycard' })
}

export const allHostList = () => {
  const obj = {
    originList: [
      'https://tlth5.weixunyijie.com', 'https://ylth5.weixunyijie.com', 'https://lth5.weixunyijie.com', 'https://tcomlog.weixunyijie.com', 'https://comlog.weixunyijie.com', // 易花普惠助手小程序
      'https://lth5.tuohuahua.com', // 易速可花（更换域名）
      'https://lth5.lzkonggu.com', // 拓花花
      'https://api.zjlzkg.com', // 易花花极速版
      'https://www.hrbzhuizhuo.cn', // 金可花V1.0.3版本之前
      'https://ltapi.hzyangshi.com', // 金可花V1.0.4版本之后
      'https://tlth5.dsgysj.com', 'https://ylth5.dsgysj.com', 'https://lth5.dsgysj.com', 'https://tcomlog.dsgysj.com', 'https://comlog.dsgysj.com',
      'https://tlth5.tcrzdb.com', 'https://tlth52.tcrzdb.com', 'https://ylth5.tcrzdb.com', 'https://lth5.tcrzdb.com', 'https://tcomlog.tcrzdb.com', 'https://comlog.tcrzdb.com', // 易花花Android和iOS包
      'https://tlth5.yijiesudai.com', 'https://tlth52.yijiesudai.com', 'https://ylth5.yijiesudai.com', 'https://lth5.yijiesudai.com', 'https://tcomlog.yijiesudai.com', 'https://comlog.yijiesudai.com', // 易借速贷Android和iOS包
      'https://lth5.blingfintech.com', // 小易金选和易花花小程序
      'https://wx.longshangxiaodai.com', // 龙商资方
      'https://kxdapp.com'
    ],
    hostList: [
      'tlth5.weixunyijie.com', 'ylth5.weixunyijie.com', 'lth5.weixunyijie.com', 'tcomlog.weixunyijie.com', 'comlog.weixunyijie.com',
      'lth5.tuohuahua.com',
      'lth5.lzkonggu.com',
      'api.zjlzkg.com',
      'www.hrbzhuizhuo.cn',
      'ltapi.hzyangshi.com',
      'tlth5.dsgysj.com', 'ylth5.dsgysj.com', 'lth5.dsgysj.com', 'tcomlog.dsgysj.com', 'comlog.dsgysj.com',
      'tlth5.tcrzdb.com', 'tlth52.tcrzdb.com', 'ylth5.tcrzdb.com', 'lth5.tcrzdb.com', 'tcomlog.tcrzdb.com', 'comlog.tcrzdb.com',
      'tlth5.yijiesudai.com', 'tlth52.yijiesudai.com', 'ylth5.yijiesudai.com', 'lth5.yijiesudai.com', 'tcomlog.yijiesudai.com', 'comlog.yijiesudai.com',
      'lth5.blingfintech.com'
    ],
    testHostList: [
      'tlth5.weixunyijie.com', 'tcomlog.weixunyijie.com',
      'tlth5.dsgysj.com', 'tcomlog.dsgysj.com',
      'tlth5.tcrzdb.com', 'tlth52.tcrzdb.com', 'tcomlog.tcrzdb.com',
      'tlth5.yijiesudai.com', 'tlth52.yijiesudai.com', 'tcomlog.yijiesudai.com'
    ],
    preHostList: [
      'ylth5.weixunyijie.com',
      'ylth5.dsgysj.com',
      'ylth5.tcrzdb.com',
      'ylth5.yijiesudai.com'
    ],
    onlineHostList: [
      'lth5.weixunyijie.com',
      'lth5.tuohuahua.com',
      'lth5.lzkonggu.com',
      'api.zjlzkg.com',
      'www.hrbzhuizhuo.cn',
      'ltapi.hzyangshi.com',
      'lth5.dsgysj.com', 'comlog.dsgysj.com',
      'lth5.tcrzdb.com', 'comlog.tcrzdb.com',
      'lth5.yijiesudai.com', 'comlog.yijiesudai.com',
      'lth5.blingfintech.com',
      'wx.longshangxiaodai.com',
      'lth5.kxdapp.com'
    ]
  }
  return obj
}

// 获取域名
export const hostInfo = ((host) => {
  const result = { isOnline: false, env: '', isIp: false, name: host, apiHost: {} }
  const hostList = allHostList().onlineHostList
  result.isOnline = hostList.includes(host)
  let prefix = ''
  if (/^(t|y)/.test(host)) {
    prefix = host[0]
    result.env = host[0] === 't' ? 'test' : 'dev'
  }
  result.isIp = /^\d/.test(host) && process.env.NODE_ENV !== 'development'
  process.env.NODE_ENV === 'development' && (result.env = 'local')
  result.apiHost.lt = prefix + 'lth5.yijiesudai.com'
  result.apiHost.ltfile = prefix + 'ltfile.yijiesudai.com'
  result.apiHost.dsj = !['local', 'test'].includes(result.env) ? 'comlog.yijiesudai.com' : 'tcomlog.yijiesudai.com'
  // result.apiHost.yx = !['local', 'test'].includes(result.env) ? 'ebgateway.yijiesudai.com' : 'tebgateway.yijiesudai.com'
  result.alifile = 'https://ltf.yijiesudai.com'
  return result
})(window.location.host)

/**
 * 渠道注册/微信下载
 */
// 已注册打开APP
export const openOrdownload = (jumpType) => {
  const t = 1000
  const preTime = Date.now()
  let hasApp = true
  // 泛舟05渠道一推完下载APP，微博渠道iOS添加白名单
  const sourceType = (getLocalData('userInfo') || {}).sourceType
  window.log('一推半流程来源sourceType：', sourceType)
  let url
  if (getOsFrom() === 'ios') {
    if (['fz05_onepushDownload'].includes(sourceType)) {
      url = 'https://fanzhou.rytad.com/ad/v1/weibo/appStore?app_store_id=1458395825'
      window.location.href = url
      return
    } else {
      if (jumpType.indexOf('yjhd') > -1) {
        url = 'https://itunes.apple.com/cn/app/id1620733748?mt=8' // 易借好贷
      } else {
        url = 'https://itunes.apple.com/cn/app/id1458395825?mt=8' // 易借速贷
      }
    }
  }
  const apkList = [
    { type: '', value: `${hostInfo.alifile}/web/apk/lzyj_duanxin.apk` },
    { type: 'sms', value: `${hostInfo.alifile}/web/apk/lzyj_duanxin.apk` },
    { type: 'gw', value: `${hostInfo.alifile}/web/apk/lzyj_gw.apk` },
    { type: 'wxgzh', value: `${hostInfo.alifile}/web/apk/lzyj_wxgzh.apk` },
    { type: 'share', value: `${hostInfo.alifile}/web/apk/lzyj_share.apk` },
    { type: 'wxfwh', value: `${hostInfo.alifile}/web/apk/lzyj_wxfwh.apk` },
    { type: 'lzyj', value: `${hostInfo.alifile}/web/apk/lzyj.apk` },
    { type: 'yjhd', value: `${hostInfo.alifile}/web/yjhd/100/unicomc_linzi.apk` },
    { type: 'yjhd_duanxin', value: `${hostInfo.alifile}/web/yjhd/100/unicomc_duanxin.apk` }
  ]
  if (getOsFrom() === 'and') {
    url = (apkList.find(item => item.type === jumpType) || {}).value
  }
  var ifr = document.createElement('iframe')
  ifr.setAttribute('src', 'linziapp://easyloan')
  ifr.setAttribute('style', 'display:none')
  document.body.appendChild(ifr)
  setTimeout(() => {
    if (Date.now() - preTime < t + 100) {
      hasApp = false
    }
  }, t)
  setTimeout(() => {
    if (hasApp) {
      return false
    } else {
      window.location.href = url
    }
    document.body.removeChild(ifr)
  }, 2000)
}

/**
 * 点击事件埋点
 * @param {*} ob
 * @param {*} argument
 */
let apiBehaviorLog
export const proxyClickDom = function (ob = {}, argument) {
  let target = argument.target
  let classname = [...target.classList].join().match(/_id_[a-zA-Z]+/g)
  let name = target.dataset ? target.dataset.type : ''
  const TYPE = {
    _id_button: { BUTTON_ID: '按钮', OPERATION_TYPE: '4' },
    _id_shurukuang: { BUTTON_ID: '输入框编码', OPERATION_TYPE: '5' },
    _id_liebiaokuang: { BUTTON_ID: '列表框', OPERATION_TYPE: '4' },
    _id_danxuanxiang: { BUTTON_ID: '单选项框', OPERATION_TYPE: '4' }
  }
  while (target && !classname && target.parentElement) {
    target = target.parentElement
    if (!name) {
      name = target.dataset ? target.dataset.type : ''
    }
    classname = [...target.classList].join().match(/_id_[a-zA-Z]+/g)
  }
  if (classname) {
    if (classname[0] === '_id_shurukuang') {
      let inputNode = target
      if (!['INPUT', 'TEXTAREA'].includes(target.tagName)) {
        inputNode = document.querySelector('.' + [...target.classList].join('.') + ' input')
      }
      if (!inputNode.dataset.hasAdd) {
        inputNode.addEventListener('blur', function () {
          apiBehaviorLog({ ...ob, testName: name, ...TYPE._id_shurukuang, OPERATION_TYPE: '6' })
          arguments[0].target.dataset.hasAdd = true
        })
      }
    }
    if (!apiBehaviorLog) {
      import('@/api/activity/marketapi.js').then(res => {
        apiBehaviorLog = res.apiBehaviorLog
        apiBehaviorLog({ ...ob, testName: name, ...TYPE[classname[0]] })
        classname = ''
      })
    } else {
      apiBehaviorLog({ ...ob, testName: name, ...TYPE[classname[0]] })
      classname = ''
    }
  }
}

export const isNumber = obj => {
  return obj === +obj
}

export function momenyFormat (number, decimals, decPoint, thousandsSep, roundtag) {
  /*
      * 参数说明：
      * number：要格式化的数字
      * decimals：保留几位小数
      * dec_point：小数点符号
      * thousands_sep：千分位符号
      * roundtag:舍入参数，默认 'ceil' 向上取,'floor'向下取,'round' 四舍五入
      * */
  number = (number + '').replace(/[^0-9+-Ee.]/g, '')
  roundtag = roundtag || 'ceil' // 'ceil','floor','round'
  var n = !isFinite(+number) ? 0 : +number
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
  var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
  var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
  var s = ''
  var toFixedFix = function (n, prec) {
    var k = Math.pow(10, prec)
    console.log()

    return '' + parseFloat(Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2)) / k
  }
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  var re = /(-?\d+)(\d{3})/
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, '$1' + sep + '$2')
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

// 数组中随机取数
export const randomArrNum = (arr, count) => {
  const shuffled = arr.slice(0)
  let i = arr.length
  const min = i - count
  let temp, index
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random())
    temp = shuffled[index]
    shuffled[index] = shuffled[i]
    shuffled[i] = temp
  }
  return shuffled.slice(min)
}

// 三方会员卡商品标识
export const thirdGoodsSign = [1, 2, 3, 4, 5, 11, 12, 13, 15, 18] // 三方商品类型goodBusModel：18权益多普通商品
export const thirdRealGoodsSign = [6, 7, 9, 10, 11, 14, 15, 16, 17, 19] // 会员订单类型orderPayType：19权益多，18预留保障计划
export const thirdGoodsRightSign = [4, 5, 6, 8, 9, 10, 11, 13, 14, 15, 16, 17, 18, 19] // 权益包券类型type：18及未保障，19权益多
export const kedangSeriesRightSign = [11, 14, 15, 17] // 可当协议族权益券共用行权参数，后端按权益主体返回独立useUrl
export const kedangGoodsSign = [7, 9, 12, 13, 14, 15, 16] // 可当协议族：卷首普通与阶梯商品必须先进入签约页
export const thirdRealGoodsSignRelation = [
  [1, 6], [2, 7], [3, 9], [4, 10], [5, 11], [11, 14], [12, 15], [13, 16], [15, 17], [18, 19], [19, 19]
]

/**
 * 统一处理返回首页：渠道 H5 会话优先安全回跳合作方，其他入口保持易借首页。
 *
 * @param {Object} options 返回选项
 * @param {boolean} options.forceYijieHome true 表示用户明确选择留在易借
 */
export const GoH5Home = ({ forceYijieHome = false } = {}) => {
  if (!forceYijieHome && redirectToChannelH5Return(router)) return
  router.push({ name: 'home_index' })
}

// 对金额逗号处理
export const formatAmount = (amount) => {
  return String(amount).replace(/(\d+)(\d{3})$/, '$1,$2')
}

/**
 * 客户端pdf协议url处理
 * @param { string || Array } protocols 协议list: [{protocolUrl: string}]或者协议url
 * @returns 正确的url或者urls
 */
export const formatPdfUrls = (protocols, isWhite) => {
  const isDev = process.env.NODE_ENV === 'development'
  const hostName = window.location.origin + `${!isDev ? getBaseStartPathname() : ''}`
  const prefixs = ['/online/', '/test/', '/dev/', '/prod/', '/pre/']
  const isAnd = getOsFrom() === 'and'
  if (Array.isArray(protocols)) {
    return protocols.map(item => {
      let url = item.protocolUrl
      !isDev && prefixs.forEach((prefix) => {
        const index = url.indexOf(prefix)
        const base = url.indexOf('pub') > 0 ? '/pub' : ''
        if (index > 0) {
          url = window.location.origin + base + url.substr(index)
        }
      })
      if (url.lastIndexOf('.pdf') >= 0) {
        item.newProtocolUrl = isAnd ? (hostName + `/static/pdf/web/viewer${isWhite ? '2' : ''}.html` + `?file=${encodeURIComponent(url)}`) : item.protocolUrl
      } else {
        item.newProtocolUrl = item.protocolUrl
      }
      return item
    })
  }
  if (typeof protocols === 'string') {
    let url = protocols
    !isDev && prefixs.forEach((prefix) => {
      const index = url.indexOf(prefix)
      if (index > 0) {
        url = window.location.origin + url.substr(index)
      }
    })
    if (url.indexOf('.pdf') >= 0) {
      return (hostName + `/static/pdf/web/viewer${isWhite ? '2' : ''}.html` + `?file=${encodeURIComponent(url)}`)
    } else {
      return url
    }
  }
}

export class HandleInputScrollTop {
  static instance = null
  static AndroidIsInit = false
  constructor (inputDom, androidScrollParent) {
    this.inputDom = inputDom
    this.androidScrollParent = androidScrollParent
    this.lastHeight = window.innerHeight
    this.init()
    if (!HandleInputScrollTop.instance) {
      HandleInputScrollTop.instance = this
    }
    return HandleInputScrollTop.instance
  }

  init = () => {
    // 检查 inputDom 是否存在，避免报错
    if (!this.inputDom) {
      return
    }
    // ios情况下
    if (/iphone|ipad|ipod|ios/i.test(navigator.userAgent)) {
      this.inputDom.addEventListener('focusin', this.onFocusPage)
    } else if (this.androidScrollParent && !HandleInputScrollTop.AndroidIsInit) {
      HandleInputScrollTop.AndroidIsInit = true
      window.addEventListener('resize', this.handleAndroidResize)
    }
  }

  onFocusPage = () => {
    const timer = setTimeout(() => {
      this.handleCalcScrollTop(window.visualViewport ? window.visualViewport.height : window.height)
      clearTimeout(timer)
    }, 300)
  }

  handleAndroidResize = (androidScrollParent) => {
    // 检查 inputDom 是否存在，避免报错
    if (!this.inputDom) {
      return
    }
    var resizeHeight = this.lastHeight - window.innerHeight // 本次变动量
    // 弹出软键盘
    if (resizeHeight > 200) {
      setTimeout(() => {
        this.handleCalcScrollTop(window.innerHeight, androidScrollParent)
      }, 150)
    }
  }

  handleCalcScrollTop = () => {
    // 检查 inputDom 是否存在，避免报错
    if (!this.inputDom) {
      return
    }
    const scrollObj = this.androidScrollParent || window
    let screenHeight = window.innerHeight
    screenHeight = screenHeight - Number(this.lastHeight === screenHeight) * 300 // ios15弹窗出现window.innerHeight 不会改变，导致输入框被遮住
    var currentInputTop = this.inputDom.getBoundingClientRect().top
    // 已经偏移（滚动）的量
    const yOffset = scrollObj === window ? window.pageYOffset : scrollObj.scrollTop
    // 不在可视视口中
    // 被软键盘遮住
    if (currentInputTop > screenHeight || this.lastHeight === window.innerHeight) {
      scrollObj.scrollTo(0, yOffset + currentInputTop - screenHeight / 2 + this.inputDom.offsetHeight / 2)
    // 滚上去了可视视口，被视口遮住
    } else if (currentInputTop < 0) {
      scrollObj.scrollTo(0, yOffset - currentInputTop - screenHeight / 2 + this.inputDom.offsetHeight / 2)
    }
  }
}

export const handleGetMockData = (config) => {
  return {
    mkMobile: sessionStorage.getItem('mobile'),
    mkdPageUrl: (sessionStorage.getItem('url') || '') + window.location.pathname,
    mkPostUrl: config.url,
    mkBeginTime: sessionStorage.getItem('beginTime'),
    mkEndTime: sessionStorage.getItem('endTime'),
    mkParams: JSON.stringify(config.data)
  }
}

// 将数字转为中文数字
export const numberToChinese = (number, type = 'upper') => {
  // 配置
  const confs = {
    lower: {
      num: ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
      unit: ['', '十', '百', '千', '万'],
      level: ['', '万', '亿']
    },
    upper: {
      num: ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'],
      unit: ['', '拾', '佰', '仟'],
      level: ['', '万', '亿']
    },
    decimal: {
      unit: ['分', '角']
    },
    maxNumber: 999999999999.99
  }

  // 过滤不合法参数
  if (Number(number) > confs.maxNumber) {
    console.error(
      `The maxNumber is ${confs.maxNumber}. ${number} is bigger than it!`
    )
    return false
  }

  const conf = confs[type]
  const numbers = String(Number(number).toFixed(2)).split('.')
  const integer = numbers[0].split('')
  const decimal = Number(numbers[1]) === 0 ? [] : numbers[1].split('')

  // 四位分级
  const levels = integer.reverse().reduce((pre, item, idx) => {
    const level = pre[0] && pre[0].length < 4 ? pre[0] : []
    const value =
      item === '0' ? conf.num[item] : conf.num[item] + conf.unit[idx % 4]
    level.unshift(value)

    if (level.length === 1) {
      pre.unshift(level)
    } else {
      pre[0] = level
    }

    return pre
  }, [])

  // 整数部分
  const _integer = levels.reduce((pre, item, idx) => {
    let _level = conf.level[levels.length - idx - 1]
    let _item = item.join('').replace(/(零)\1+/g, '$1') // 连续多个零字的部分设置为单个零字

    // 如果这一级只有一个零字，则去掉这级
    if (_item === '零') {
      _item = ''
      _level = ''

      // 否则如果末尾为零字，则去掉这个零字
    } else if (_item[_item.length - 1] === '零') {
      _item = _item.slice(0, _item.length - 1)
    }

    return pre + _item + _level
  }, '')

  // 小数部分
  const _decimal = decimal
    .map((item, idx) => {
      const unit = confs.decimal.unit
      const _unit = item !== '0' ? unit[unit.length - idx - 1] : ''

      return `${conf.num[item]}${_unit}`
    })
    .join('')

  // 如果是整数，则补个整字
  return `${_integer}元` + (_decimal || '整')
}

/**
 * @name 获取倒计时时间
 * @param {number} seconds 倒计时秒数
 * @param {1 | 2 | 3} type 返回类型： 1：00:00:60，2：0天00时00分60秒，3：60
 * @return {string}
 */
export class CountDown {
  constructor (seconds, timeContainer, type) {
    this.timer = null
    this.seconds = seconds
    this.curTime = Date.now()
    this.isPaused = false
    this.type = type || 3
    this.time = timeContainer
    this.time.value = formatSeconds(this.seconds, this.type)
  }

  run = () => {
    if (this.isPaused) return
    const diffTime = Math.floor((Date.now() - this.curTime) / 1000)
    this.curTime = Date.now()
    this.seconds -= diffTime
    clearTimeout(this.time)
    if (this.seconds > 0) {
      this.timer = setTimeout(this.run, 1000)
    } else {
      this.seconds = 0
      this.clear()
    }
    this.time.value = formatSeconds(this.seconds, this.type)
  }

  clear = () => {
    if (this.timer) clearTimeout(this.timer)
  }

  start = () => {
    this.isPaused = false
    this.curTime = Date.now()
    this.run()
  }

  pause = () => {
    this.isPaused = true
    this.clear()
  }
}

/**
 * @name 日期时间格式化
 * @param {number} seconds 倒计时秒数
 * @param {1 | 2 | 3} type 格式化类型：1：00:00:60，2：0天00时00分60秒，3：60
 * @return {String}
 */
export function formatSeconds (seconds, type) {
  const days = Math.floor(seconds / 86400)
  const hours = Math.floor((seconds % 86400) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const remainingSeconds = seconds % 60

  if (type === 1) {
    return `${days ? `${days.toString().padStart(2, '0')}:` : ''}${hours
      .toString()
      .padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`
  } else if (type === 2) {
    return `${days ? `${days}天` : ''}${hours
      .toString()
      .padStart(2, '0')}时${minutes
      .toString()
      .padStart(2, '0')}分${remainingSeconds.toString().padStart(2, '0')}秒`
  } else if (type === 3) {
    return String(seconds)
  } else {
    throw new Error('Invalid format type')
  }
}

// url参数变成参数字符串
export const getQuerystring = (data) => {
  return Object.keys(data).reduce((str, k) => {
    str += `${encodeURIComponent(k)}=${encodeURIComponent(data[k])}&`
    return str
  }, '').slice(0, -1)
}

// 跳转页面
export const handleGoThirdPage = (url, urlParams) => {
  if (!url) return
  if (url.startsWith('https') && !url.includes('/unicom/')) {
    window.location.href = urlParams ? url + '?' + getQuerystring(urlParams) : url
  } else {
    const tempParams = { ...getUrlPara2(url), ...(urlParams || {}) }
    const tempAppRoute = getVueRoutePathnameFromUrl(url)
    const tempPath = tempAppRoute.split(/[?#]/)[0]
    router.push({ path: tempPath, query: tempParams })
  }
}

/**
 * @title pdf转换成html文件展示
 * @param {*} url 协议完整的pdf链接
 * @param {*} name 协议名称
 */
export const handleCanvasPdf = (url, name) => {
  const urlArr = ['/online/', '/test/', '/dev/', '/prod/', '/pre/']
  urlArr.forEach((item) => {
    const index = url.indexOf(item)
    if (index > 0) {
      url = window.location.origin + url.substr(index)
    }
  })
  sessionStorage.setItem('picUrl', url)
  sessionStorage.setItem('picUrlName', name)
  const isDev = 'development'
  window.location.href = window.location.origin + `${process.env.NODE_ENV !== isDev ? getFullPathname('/static/pdf/web/viewer.html') : '/static/pdf/web/viewer.html'}`
}

// 校验响应数据
export const validateData = (schema, data) => {
  try {
    return schema.parse(data)
  } catch (error) {
    if (error instanceof z.ZodError) {
      const errs = error.errors.reduce((errResult, cur) => {
        const val = cur.path.reduce((objVal, key) => objVal[key], data)
        const path = cur.path.join('.')
        errResult[path] = `val: ${val}, errMsg: ${cur.message}`
        return errResult
      }, {})
      window.log('zod validate error: ', errs)
    } else {
      console.error('zod unexpected error:', error)
    }
    return data
  }
}

// 获取大数据埋点接口域名
export const getDsjDomain = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'https://tcomlog.yijiesudai.com'
  } else {
    if (['www.hrbzhuizhuo.cn', 'api.zjlzkg.com'].includes(window.location.host)) {
      return window.location.origin
    } else {
      return window.location.origin.replace(/tlth52|tlth5/g, 'tcomlog').replace(/ylth5|lth5/g, 'comlog')
    }
  }
}

// 获取 CDN 静态资源域名
export const getCdnDomain = () => {
  if (process.env.NODE_ENV === 'development') {
    // 开发环境使用测试 CDN
    return 'https://ltf-pub.yijiesudai.com'
  } else {
    // 兼容部分不支持 window.location.origin 的环境，确保包含 /pub 路径
    const origin = window.location.origin || (window.location.protocol + '//' + window.location.host)
    return `${origin}/pub`
  }
}

export const getQuerystringUrl = (url, data) => {
  if (!data) return url
  const queryString = Object.keys(data).reduce((str, k) => {
    str += `${encodeURIComponent(k)}=${encodeURIComponent(Base64.encodeURI(String(typeof data[k] === 'object' ? JSON.stringify(data[k]) : data[k])))}&`
    return str
  }, '').slice(0, -1)
  return url + (url.includes('?') ? '&' : '?') + queryString
}

// 获取旧版协议模版css样式
const PAGE_CLASS_MAP = {
  1: 'operation-dynamic-page1',
  2: 'operation-dynamic-page2'
}
const PAGE0_IDS = new Set([
  4, 5, 6, 7, 8, 9,
  10, 11, 12, 13, 14, 15, 16, 18, 19,
  21, 25, 26, 27, 28, 33, 35, 36, 37, 38, 39,
  40, 41, 42, 43, 44, 45, 46, 47, 48, 49,
  50, 51, 52, 55, 58, 59,
  60, 61, 62, 63, 64, 65, 66, 67, 68, 69,
  70, 71, 72, 73, 74, 75, 76, 77, 78, 79,
  80, 85, 86, 87, 88, 89,
  90, 91, 92, 93, 94, 95, 96, 97, 98, 99,
  100, 101, 102, 103, 104, 105, 106, 107, 108,
  113, 114, 118, 119,
  120, 121, 123, 124, 126, 127, 128, 129,
  130, 131, 132, 133, 134, 135, 136, 137, 138, 139,
  143, 144, 145, 146,
  154, 155, 156, 157, 158, 159,
  160, 162, 163, 164, 165, 166, 167, 168, 169,
  170, 171, 172, 177, 179,
  181, 182, 183, 185, 186, 187
])
export const getProtocolCssUrl = (id) => {
  const targetDiv = document.querySelector('.operation-dynamic-page')
  if (!targetDiv) return

  // 清理旧样式
  targetDiv.classList.remove(
    'operation-dynamic-page0',
    'operation-dynamic-page1',
    'operation-dynamic-page2'
  )
  let className = PAGE_CLASS_MAP[id]
  if (!className && PAGE0_IDS.has(id)) {
    className = 'operation-dynamic-page0'
  }
  className && targetDiv.classList.add(className)
}
